import { render, staticRenderFns } from "./By.vue?vue&type=template&id=46e31561&scoped=true&"
import script from "./By.vue?vue&type=script&lang=js&"
export * from "./By.vue?vue&type=script&lang=js&"
import style0 from "./By.vue?vue&type=style&index=0&id=46e31561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e31561",
  null
  
)

export default component.exports